export default {
  data() {
    return {
      __mounteDateNow__: 0
    };
  },
  created() {
    // 处理由vue-navigation引起的mounted和activated事件同时执行的问题
    if (this.$options.activated) {
      this.$options.activated = this.$options.activated.map((fn) => {
        return function () {
          // 说明触发的时机很接近
          if (Date.now() - this.__mounteDateNow__ < 50) {
            return;
          }
          return fn.call(this);
        };
      });
    }
  },
  mounted() {
    this.__mounteDateNow__ = Date.now();
  },
  activated() {
    if (this.$router && this.$router.pageEvents && this.$options.name) {
      let name = this.$options.name;
      if (name in this.$router.pageEvents) {
        let eventFn = this.$router.pageEvents[name];
        eventFn.call(this);
        eventFn = null;
        this.$router.clearEvent(name);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/mixins/eventMixin.js